<template>
  <div>
    <confirm-modal
      :title="modalInactiveChild.title"
      :confirm-button="modalInactiveChild.confirmButton"
      :modalId="MODAL_ID"
    >
      {{ modalInactiveChild.text }}
    </confirm-modal>
    <nav-bar :title="'Change Student'" class="py-3" hideBackButton></nav-bar>
    <div class="mobile bg-white text-right" :class="theme">
      <button
        v-if="childSelectedId && childrenList.length"
        type="button"
        class="shareChildButton atm-button bg-light text-main rounded-pill px-3 py-1"
        @click="$bvModal.show('shareChild')"
        :disabled="!childrenList"
      >
        Share child
      </button>
    </div>
    <div>
      <div
        class="atm-rounded d-flex gap-4 flex-column justify-content-center align-items-center mx-0 py-2"
        :class="{ childSelectedId: 'atm-shadow' }"
        :style="childSelectedId ? '' : 'top: -125px'"
      >
        <div class="text-center">
          <h5>Welcome {{ sessionStore.userName }}</h5>
          <p>
            Please select the profile of the student to administer:
          </p>
        </div>
        <div
          v-for="item in childrenList"
          class="childCard position-relative d-flex justify-content-between align-items-center px-0 my-3 rounded-pill w-75"
          :class="{ 'child-inactive': !item.childIsActive }"
          :key="item.id"
          @click="selectChild(item)"
        >
          <div class="childImage rounded-circle atm-shadow rounded-pill bg-light">
            <img
              fluid
              :src="item.avatar ? item.avatar : require(`@/assets/avatar.png`)"
              alt="Badge icon"
            />
          </div>
          <div
            class="childInfo atm-shadow d-flex flex-grow-1 justify-content-between align-items-center rounded-pill pl-5 ml-5"
          >
            <span class="ellipsis font-weight-bold text-capitalize pl-2">
              {{ item.name }} {{ item.lastName }}
            </span>
            <div class="position-relative">
              <div
                class="coin-container position-relative d-flex justify-content-center align-items-center"
              >
                <img :src="require('@/assets/coin2.png')" alt="" />
                <label class="coins-value position-absolute font-weight-bolder m-0">
                  {{ item.coins }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <share-child-modal
        v-if="childrenList.length"
        :childrenData="childrenList"
      ></share-child-modal>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { persisteChildSelection } from '@/auth';
import { updateChildInformation } from '@/common/services';
import { NavBar, ConfirmModal } from '@/common/components';
import ShareChildModal from '@/common/components/modal/ShareChildModal';
import { getThemeColor } from '@/common/utils';

export default {
  components: {
    NavBar,
    ConfirmModal,
    ShareChildModal,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      childrenList: [],
      userName: '',
      inactiveChildId: null,
      MODAL_ID: 'inactive-child',
      modalInactiveChild: {
        title: '',
        text: 'You want to enable this child?',
        confirmButton: () => this.enableChild(),
      },
    };
  },
  computed: {
    childSelectedId() {
      return this.sessionStore.childSelectedId;
    },
    childsList() {
      return this.sessionStore.children;
    },
    theme() {
      return `bg-${getThemeColor(this.sessionStore.themeSelection)}`;
    },
    userId() {
      return this.sessionStore.userId;
    },
  },
  methods: {
    goToMainRoute(child) {
      persisteChildSelection(`${child.id}`);
      this.$router.push('/');
    },
    selectChild(child) {
      if (child.childIsActive) {
        this.goToMainRoute(child);
        return;
      }
      this.modalInactiveChild.title = `${child.name} is disabled`;
      this.inactiveChildId = child.id;
      this.$bvModal.show(this.MODAL_ID);
    },
    async enableChild() {
      try {
        const enableChild = true;
        const userInfo = await updateChildInformation(this.userId, this.inactiveChildId, {
          isActive: enableChild,
        });
        delete userInfo.avatar;
        this.sessionStore.setChildInfo(userInfo);
        this.goToMainRoute(userInfo);
      } catch (error) {
        console.error(error);
      }
    },
  },
  async mounted() {
    this.childrenList = this.childsList;
  },
};
</script>
<style lang="scss">
.bg-badge {
  overflow: hidden;
  height: 45px;
  width: 45px;
}
.badge__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.shareChildButton {
  height: fit-content;
}

.childCard {
  height: 50px;
  cursor: pointer;
}

.childImage {
  position: absolute;
  top: -35%;
  width: 85px;
  height: 85px;
  overflow: hidden;
  z-index: 400;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.childInfo {
  height: 100%;
  position: relative;
  .ellipsis {
    width: max(28vw, 100px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.coin-container {
  width: 50px;
  height: 50px;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  & .coins-value {
    font-size: 1rem;
    width: min-content;
    height: min-content;
    top: 17.5%;
  }
}
.child-inactive {
  filter: grayscale(100%);
}
</style>
